import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import './styles/index.css';
// DOPO index.css, sempre: mobile.css non riscrive niente, aggiunge le regole
// del telefono e per vincere a parità di specificità deve arrivare per ultimo.
import './styles/mobile.css';
import { adottaKatanaIniziale } from './lib/katana';

// Lo sfodero della katana e' gia' in pagina (index.html) e sta gia' girando:
// qui si prende solo in carico, per toglierlo a fine corsa. Va fatto PRIMA del
// render, cosi' anche se React ci mette un attimo il nodo ha gia' chi lo
// aspetta. Sul computer si toglie e basta.
adottaKatanaIniziale();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
